<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div id="groupModal2" class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg max-width-100" @click.stop >
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="width-100">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal-body- modal_add_rep d-none- mb-3 ml-3">


          
        <div class="row mb-2 pl-3 pb-2 border-bottom ml-2" v-for="option in 5" v-if="loading == true">
          <div class="col-12 pl-2 pt-2">
            <div class="col-12">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-10">
            <PuSkeleton :count="1"></PuSkeleton>
            </div>
          </div>
        </div>

                <div class="row mt-2 mb-3 align-items-end" v-if="loading == false">
                  <div class="col-9">
                    <div class="h4 mb-0">{{ pathwayName }}</div>
                  </div>
                  <div class="col-3">
                    <div v-if="logs.length > 0" class="downIcon"  @click="downloadFunc()">
                      <img v-if="logs.length > 0"  class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px" />
                    </div>
                  </div>
                </div>


                <div class="row mt-2 mb-3 align-items-end" v-if="loading == false">
                  <div class="col-6">
                    <div class="h6 mb-0 history">History</div>
                  </div>
                  <div class="col-6 pr-0">
                    <div class="col-12 float-left" style="padding-right: 18px !important;">
                      <div class="cp-filter-label col-4 p-0 float-left mt-5">Date Range:</div>
                      <b-form-select v-model="rep_days" 
                      @change="getLogs()"
                      :options="itemSource2" class="col-8 float-left rep_days" />
                    </div>
                      
                  </div>
                </div>



                <div class="row">
                  <div class="col">
                    <div class="row mb-2 pl-3 pr-3" v-for="(log, index) in logs" :key="index">
                      <div class="col">
                        <div class="row pb-2 border-bottom">
                          <div class="col-9">
                            <div class="mb-0">{{ log.title }}</div>
                            <div class="small text-muted mb-0">{{ log.description }}</div>
                          </div>
                          <div class="col-3 small text-right text-muted">{{ log.createdAtFormatted }}</div>
                        </div>
                      </div>
                    </div>
                    
                    

                    <div class="row" v-if="logs.length == 0 && loading == false">
                      <div class="col">
                        <div>No logs found.</div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>

            </div>
            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import axios from 'axios';
import router from '../../router/index.js';

export default {
  props: ['isModalVisible'],
  data() {
    return {
      logs: [],
      pathwayId: '',
      apiUrl: '',
      loading: false,
      pathwayName: '',
      itemSource2: [
          { value: "", text: "Select Date Range" }, 
          { value: "7", text: "Last 7 days" }, 
          { value: "15", text: "Last 15 days" },
          { value: "30", text: "Last 30 days" },
          { value: "180", text: "Last 6 Months" },
          { value: "All", text: "All Time" }
      ],
      rep_days: 7,
    }
  },
  computed: {
    
  },
  methods: {
    hide() {
      this.$emit('closeLogFullListModal');
    },
    getActivityData(pathwayId) {
      this.pathwayId = pathwayId;
      this.rep_days = 7;
      this.logs = [];
      this.getLogs();  
    },
    downloadFunc: function() {

      const params = {};
      if (this.rep_days) {
          params.days = this.rep_days;
      } else {
          params.days = '';
      }
      params.accountId = this.$store.state.user_accountid;
      params.pathwayId = this.pathwayId;
      axios('/desktop/v2/get-pathway-log/full-list-pdf', {
        method: 'GET',
        params: params
      })
      .then(response =>  {
          this.pdf_file_name = response.data.pdf_file_name;
          var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
     
          //Create XMLHTTP Request.
          var req = new XMLHttpRequest();
          req.open("GET", url, true);
          req.responseType = "blob";
          req.onload = function () {
              //Convert the Byte Data to BLOB object.
              var blob = new Blob([req.response], { type: "application/octetstream" });

              //Check the Browser type and download the File.
              var isIE = false || !!document.documentMode;
              if (isIE) {
                  window.navigator.msSaveBlob(blob, fileName);
              } else {
                  var url = window.URL || window.webkitURL;
                  var link = url.createObjectURL(blob);
                  var a = document.createElement("a");
                  a.setAttribute("download", "pathway_audit_log.pdf");
                  a.setAttribute("href", link);
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
              }
          };
          req.send();
          return false;
        })
        .catch(function(error) {
            console.log(error);
        });


    },

    getLogs() {
      this.logs = [];
      this.loading = true;
      const params = {};
      if (this.rep_days) {
          params.days = this.rep_days;
      } else {
          params.days = '';
      }
      params.accountId = this.$store.state.user_accountid;
      params.pathwayId = this.pathwayId;
      axios.get('/desktop/v2/get-pathway-log/full-list', {
        params: params
      })
      .then(response =>  {
        let data = response.data;
        this.loading = false;
        this.pathwayName = data.pathwayName;
        this.logs = this.logs.concat(data.logs);
      })
      .catch(function() {});
    },
  },
  components: {
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}

a {
  color: #00ACEE;
}

a:hover,
a:active,
a:focus {
  color: #00ACEE;
}

::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-mask1 {
    position: fixed;
    z-index: 1001;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
.rep_days {
  margin-bottom: 10px !important; margin-top: 12px;
}
.max-width-100 {
  max-width: 100%;
}
.width-100 {
  width: 100%;
}
.downIcon {
  margin-left: 15px; margin-top: 3px; float: right; margin-right: 0px; margin-top: 2px;
}
.history {
  margin-top: -40px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/pathway_audit_log_full_list.vue